<template>
  <!--
    游标分页公共组件（纯 UI 受控）：
    - 只消费 total / hasMore / hasPrevious，不发起请求、不读取响应、不加工业务数据
    - 游标如何取、请求怎么发，全部由调用方页面内部处理
    - 页码在游标模式下无业务含义，仅用于推导「上一页 / 下一页」的禁用态
  -->
  <el-pagination
    class="cursor-pagination"
    layout="slot, sizes, prev, next"
    :current-page.sync="pagerCurrent"
    :page-count="pagerPageCount"
    :page-size="pageSize"
    :page-sizes="pageSizes"
    :background="background"
    @prev-click="onPrevClick"
    @next-click="onNextClick"
    @size-change="onSizeChange"
  >
    <slot>
      <span class="cursor-pagination__total">共 {{ total }} 条</span>
    </slot>
  </el-pagination>
</template>

<script>
export default {
  name: 'CursorPagination',

  props: {
    // 总条数（仅用于展示，不参与页数推导）
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    },
    // 是否还有下一页
    hasMore: {
      type: Boolean,
      default: false
    },
    // 是否还有上一页（单向游标场景可由调用方用 pageNumber > 1 派生）
    hasPrevious: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      pagerCurrent: 1
    };
  },

  computed: {
    // 上一页在 pagerCurrent 为 1 时禁用，下一页在 pagerCurrent 等于总页数时禁用
    pagerPageCount() {
      if (!this.hasPrevious) {
        return this.hasMore ? 2 : 1;
      }
      return this.hasMore ? 3 : 2;
    }
  },

  watch: {
    hasMore() {
      this.syncPagerCurrent();
    },
    hasPrevious() {
      this.syncPagerCurrent();
    }
  },

  created() {
    this.syncPagerCurrent();
  },

  methods: {
    // 页码归位到 hasPrevious / hasMore 推导出的位置，保证点击后禁用态仍然正确
    syncPagerCurrent() {
      this.pagerCurrent = this.hasPrevious ? 2 : 1;
    },

    onPrevClick() {
      this.$emit('prev-click');
      // el-pagination 内部页码会在下一帧同步，等它写完再归位
      this.$nextTick(this.syncPagerCurrent);
    },

    onNextClick() {
      this.$emit('next-click');
      this.$nextTick(this.syncPagerCurrent);
    },

    onSizeChange(size) {
      this.$emit('size-change', size);
    }
  }
};
</script>

<style scoped>
.cursor-pagination__total {
  font-weight: normal;
}
</style>
